import { render, staticRenderFns } from "./InsertLink.vue?vue&type=template&id=2cbc2748&scoped=true&"
import script from "./InsertLink.vue?vue&type=script&lang=js&"
export * from "./InsertLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc2748",
  null
  
)

export default component.exports